import React from "react";

const DocumentsPage: React.FC = () => {
  return (
    <div style={{ padding: 16 }}>
      <h1>Documente</h1>
      <p>În curând: gestionarea documentelor relevante pentru Mindspace.</p>
    </div>
  );
};

export default DocumentsPage;


